import {useHistory, useLocation} from "react-router-dom";
import {useCallback, useEffect, useState} from "react";

const PREVIEW_FILE_PARAM = "preview_file"

export const useContractorFilePreview = (files) => {
    const [previewedFile, setPreviewedFile] = useState(null)
    const history = useHistory()
    const location = useLocation()

    const handlePreviewFileChange = useCallback(file => {
        const params = new URLSearchParams(location.search)
        params.set(PREVIEW_FILE_PARAM, file.id)
        history.replace({
            pathname: location.pathname,
            search: "?" + params.toString()
        })
    }, [history, location])

    const removeFilePreviewParam = useCallback(() => {
        const params = new URLSearchParams(location.search)
        params.delete(PREVIEW_FILE_PARAM)
        history.replace({
            pathname: location.pathname,
            search: "?" + params.toString()
        })
    }, [location, history])

    const handleFilePreviewClose = useCallback(() => {
        removeFilePreviewParam()
    }, [removeFilePreviewParam])

    useEffect(() => {
        const previewFile = new URLSearchParams(location.search).get(PREVIEW_FILE_PARAM)
        if (previewFile !== null) {
            const file = files.find(it => it.id === previewFile)
            if (file) {
                setPreviewedFile(file)
            } else {
                removeFilePreviewParam()
            }
        } else {
            setPreviewedFile(null)
        }
    }, [location, removeFilePreviewParam, files])

    return {
        previewedFile,
        handleFilePreviewClose,
        handlePreviewFileChange
    }
}